import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";

const GetUser = async (uid) => {
  if (uid === undefined) {
    return;
  }
  try {
    const UsersDocument = await doc(db, "Users", uid);
    const UserDocumentSnapshot = await getDoc(UsersDocument);
    const UserDocumentDetails = UserDocumentSnapshot.data();
    return UserDocumentDetails;
  } catch (error) {
    console.log(error);
  }
};

export default GetUser;
